import { ACTIONPLANS_ACTIONS_MODULE_NAME } from '@/store/modules/actionplans/constants';
import module from './module';
import plugins from './plugins';
import registerUserExchanges from './userExchanges';

export default (store) => {
  const MODULE_NAME = ACTIONPLANS_ACTIONS_MODULE_NAME;
  const MODULE_PATH = MODULE_NAME.join('/');

  store.registerModule(MODULE_NAME, module);

  plugins(store, MODULE_PATH);

  registerUserExchanges(store);
};
